import { apiClient } from '@/lib/api/client';
import {
    Notification,
    NotificationListResponse,
    NotificationType,
} from '@/types/api.types';

interface NotificationFilters {
    is_read?: boolean;
    type?: NotificationType;
    page?: number;
    limit?: number;
}

export const notificationService = {
    /**
     * List user's notifications
     * GET /notifications
     */
    getNotifications: async (
        filters?: NotificationFilters
    ): Promise<NotificationListResponse> => {
        const { data } = await apiClient.get<NotificationListResponse>('/notifications', {
            params: filters,
        });
        return data;
    },

    /**
     * Get count of unread notifications
     * GET /notifications/unread-count
     */
    getUnreadCount: async (): Promise<{ count: number }> => {
        const { data } = await apiClient.get<{ count: number }>('/notifications/unread-count');
        return data;
    },

    /**
     * Get specific notification
     * GET /notifications/{notification_id}
     */
    getNotification: async (id: string): Promise<Notification> => {
        const { data } = await apiClient.get<Notification>(`/notifications/${id}`);
        return data;
    },

    /**
     * Mark notification as read
     * PUT /notifications/{notification_id}/read
     */
    markAsRead: async (id: string): Promise<Notification> => {
        const { data } = await apiClient.put<Notification>(`/notifications/${id}/read`);
        return data;
    },

    /**
     * Mark multiple notifications as read
     * POST /notifications/mark-multiple-read
     */
    markMultipleAsRead: async (ids: string[]): Promise<void> => {
        await apiClient.post('/notifications/mark-multiple-read', {
            notification_ids: ids,
        });
    },

    /**
     * Mark all notifications as read
     * POST /notifications/mark-all-read
     */
    markAllAsRead: async (): Promise<void> => {
        await apiClient.post('/notifications/mark-all-read');
    },

    /**
     * Delete a notification
     * DELETE /notifications/{notification_id}
     */
    deleteNotification: async (id: string): Promise<void> => {
        await apiClient.delete(`/notifications/${id}`);
    },
};
